/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * test
 */
let protocol = location.protocol
let config = {}

console.log('process.env.NODE_ENVvvvvvvvvvvvvvvvvvvvvvvvvvvv', process.env.NODE_ENV)
switch (process.env.NODE_ENV) {
  case 'development':
    /*
    * 开发环境    => npm run dev
    */
    config = {
        // baseUrl: `${protocol}//xiaoxapi.aoji.cn`,
        baseUrl: `${protocol}//test-xiaoxapi.aoji.cn`,
        // baseUrl: `${protocol}//192.168.16.15:1600`,
        // baseUrl: `${protocol}//192.168.160.136:8081`,
        baseUrl1: `${protocol}//test-stuapi.xiaoxiedu.com`,
        // baseUrl1: `${protocol}//stuapi.xiaoxiedu.com`,
        // baseUrl1: `${protocol}//192.168.11.71:1600`,
        // baseUrl1: `${protocol}//192.168.16.215:1602`,
        // baseUrl1: `${protocol}//192.168.0.138:1602`,
        baseUrl2: `${protocol}//test-scapi.xiaoxiedu.com`,
        // baseUrl2:`http://192.168.16.7:1616`,
        autoAuth: true,// 开发环境 自动授权
        devState: true// 开发环境 bug调试模式开启
    }
    break;
  case 'production':
    /*
     * 线上环境 => npm run build
     */
    config = {
      baseUrl: `${protocol}//xiaoxapi.aoji.cn`,
      baseUrl1: `${protocol}//stuapi.xiaoxiedu.com`,
      baseUrl2: `${protocol}//scapi.xiaoxiedu.com`,
    }
    break;
  case 'dev':
    /**
    * 打包开发环境 => npm run build:dev
    */
    config = {
      baseUrl: `${protocol}//192.168.160.136:8081`,//顾问开发境
      baseUrl1: `${protocol}//192.168.11.71:1600`,//学生端开发境
      baseUrl2: `${protocol}//192.168.16.84:1616`,//语言测评开发环境
      autoAuth: false,// 开发环境 自动授权
      devState: true// 开发环境 bug调试模式开启
    }
    break;
  case 'test':
    /**
    * 打包测试环境 => npm run build:test
    */
    config = {
      baseUrl: `${protocol}//test-xiaoxapi.aoji.cn`,//顾问测试境
      baseUrl1: `${protocol}//test-stuapi.xiaoxiedu.com`,//学生端测试境
      baseUrl2: `${protocol}//test-scapi.xiaoxiedu.com`,//语言测评测试环境
      autoAuth: false,// 开发环境 自动授权
      devState: true// 开发环境 bug调试模式开启
    }
    break;
  case 'uat':
    /**
    * 打包测试环境 => npm run build:test
    */
    config = {
      baseUrl: `${protocol}//uat-xiaoxapi.aoji.cn`,//顾问测试境
      baseUrl1: `${protocol}//uat-stuapi.xiaoxiedu.com`,//学生端测试境
      baseUrl2: `${protocol}//uat-scapi.xiaoxiedu.com`,//语言测评测试环境
      autoAuth: false,// 开发环境 自动授权
      devState: true// 开发环境 bug调试模式开启
    }
    break;
}

export default config



// WEBPACK FOOTER //
// ./config/env.js